import React from 'react';
import { transformationData } from '../data/mock';
import useScrollAnimation from '../hooks/useScrollAnimation';
import TransformationVisual from './graphics/TransformationVisual';

export const TransformationSection = () => {
  const [titleRef, titleVisible] = useScrollAnimation({ threshold: 0.3 });
  const [visualRef, visualVisible] = useScrollAnimation({ threshold: 0.15 });
  const [promiseRef, promiseVisible] = useScrollAnimation({ threshold: 0.3 });

  return (
    <section className="bg-[#fffef2] py-24 lg:py-32 relative overflow-hidden">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#e8e7da] to-transparent" />
      
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        {/* Section Title */}
        <div
          ref={titleRef}
          className={`text-center mb-16 lg:mb-20 animate-on-scroll ${titleVisible ? 'is-visible' : ''}`}
        >
          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl text-[#333333] leading-tight">
            {transformationData.sectionTitle}
          </h2>
        </div>

        {/* Transformation Visual */}
        <div 
          ref={visualRef}
          className={`mb-16 scale-in ${visualVisible ? 'is-visible' : ''}`}
        >
          <TransformationVisual isVisible={visualVisible} />
        </div>

        {/* Promise */}
        <div 
          ref={promiseRef}
          className={`text-center fade-in ${promiseVisible ? 'is-visible' : ''}`}
        >
          <div className="inline-flex flex-col items-center gap-4">
            <div className="flex items-center gap-3">
              <div className="w-8 h-px bg-gradient-to-r from-transparent to-[#5a7fa8]" />
              <div className="w-2 h-2 rounded-full bg-[#c9a87c]" />
              <div className="w-8 h-px bg-gradient-to-l from-transparent to-[#5a7fa8]" />
            </div>
            <p className="font-serif text-lg md:text-xl text-[#333333]">
              {transformationData.promise}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
